<template>
    <div class="v-search d-flex v-text-field--single-line v-text-field--rounded"
        :class="{ 'v-text-field--solo': !flat, 'v-text-field': !flat, 'eod-search__topbar': topbar, 'v-search--active': hasActiveFilters }">
        <div class="v-input__control">
            <div class="v-input__slot" :style="flat ? 'margin-bottom:0;' : ''">
                <v-icon small>mdi-filter-variant</v-icon>
                <div class="d-flex flex-grow-1 v-search__filter-wrapper" :class="{open:isDropdownOpen, active:hasActiveFilters, collapsable:($refs['search__filter-items']?.getBoundingClientRect().height || 0) > 40}">

                    <div ref="search__filter-items" class="v-search__filter-items d-flex flex-wrap">
                        <v-btn color="grey lighten-2" depressed rounded class="v-search__filter-dropdown" @click="isDropdownOpen = !isDropdownOpen" small v-if="($refs['search__filter-items']?.getBoundingClientRect().height || 0) > 40"><v-icon small v-if="isDropdownOpen">mdi-chevron-up</v-icon><v-icon small v-else>mdi-dots-horizontal</v-icon></v-btn>
                        <div class="v-search__filter-item align-items-center" v-for="(filter, index) in value"
                            :key="index">
                            <input v-if="filter.result" type="hidden"
                                :name="'filter[' + filter.config.filter + ']' + (filter.config.type == 'property' ? '' : '[]')"
                                :value="filter.result.id + '|' + filter.result.search_title">
                            <span class="v-search__filter-item__label">{{ filter.config.label }}</span>
                            <span class="v-search__filter-item__result" :class="filter.config.readonly?'v-search__filter-item__result-readonly':''" v-if="filter.result">{{
                                filter.result.search_title
                            }}</span>
                            <v-icon class="v-search__filter-item__delete" small v-if="filter.result && !filter.config.readonly"
                                @click.stop="removeFilter(index)">mdi-close-circle</v-icon>
                        </div>
                        <div class="v-search__filter-input" v-if="!readonly">
                            <v-menu v-model="showMenu" transition="scale-transition" offset-y max-width="310"
                                :close-on-content-click="false">
                                <template v-slot:activator="{ attrs }">
                                    <input name="q" ref="input_search" v-bind="attrs" @focus="focusIn" @click="focusIn" @blur="focusOut"
                                        v-model="search" placeholder="Typ om te filteren..." type="search" autocomplete="off" @keydown="searching($event)">
                                </template>
                                <v-card>
                                    <eod-date-range v-model="dateRange" @input="changeDate"></eod-date-range>
                                    <v-card-actions>
                                        <v-btn color="primary" :disabled="!dateRange[0] || !dateRange[1]" block depressed @click="setDate">Instellen</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-menu>
                            <div class="v-search__dropdown" v-if="show_types">
                                <div class="v-search__dropdown-item" :class="type.selected ? 'active' : ''"
                                    v-for="(type, index) in types" :key="index"
                                    @mousedown="addTypeToFilter($event, type)">
                                    <v-icon>{{ type.icon }}</v-icon>{{ type.label }}
                                </div>
                            </div>
                            <div class="v-search__dropdown" v-if="items.length > 0">
                                <div class="v-search__dropdown-item" :class="item.selected ? 'active' : ''"
                                    v-for="item in items" :key="item.id" @mousedown="addItemToFilter($event, item)">
                                    {{ item.search_title }}
                                </div>
                                <div v-if="module_items_totalcount > 0" class="v-search__dropdown-footer">
                                    {{ items.length }} van {{ module_items_totalcount }}
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <v-tooltip bottom v-if="!readonly">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn icon small v-bind="attrs" v-on="on" @click="resetFilter">
                            <v-icon small>mdi-close</v-icon>
                        </v-btn>
                    </template>
                    <span>Wissen</span>
                </v-tooltip>
                <v-dialog v-if="value.length > 0 && value[value.length - 1].result != null && objectType && !readonly"
                    v-model="saveDialog" width="500" max-width="100%">
                    <template v-slot:activator="{ on: menu, attrs }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on: tooltip }">
                                <v-btn icon small v-bind="attrs" v-on="{ ...tooltip, ...menu }" @click="prepareNewFilter" class="ml-2">
                                    <v-icon small>mdi-content-save</v-icon>
                                </v-btn>
                            </template>
                            <span>Filter opslaan</span>
                        </v-tooltip>
                    </template>
                    <v-card>
                        <v-card-title class="mb-4">
                            <v-avatar color="primary" size="40" class="elevation-3 mr-4">
                                <v-icon dark small>
                                    mdi-content-save
                                </v-icon>
                            </v-avatar><span class="headline">{{ editingFilterId ? 'Filter aanpassen' : 'Opslaan' }}</span>
                        </v-card-title>
                        <v-card-text>
                            <v-text-field v-model="newFilterList" dense outlined label="Naam" required></v-text-field>
                            <v-select v-model="filterAccess" :items="accessTypes" item-value="value" item-text="text"
                                dense outlined hide-details label="Zichtbaarheid">
                                <template v-slot:selection="{ item }">
                                    <v-icon left small>{{ item.icon }}</v-icon>{{ item.text }}
                                </template>
                                <template v-slot:item="{ item }">
                                    <v-list-item-icon class="mr-2"><v-icon small>{{ item.icon }}</v-icon></v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>{{ item.text }}</v-list-item-title>
                                        <v-list-item-subtitle class="text-wrap">{{ item.info }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </template>
                            </v-select>
                        </v-card-text>
                        <v-card-actions class="grey lighten-3 py-3 px-3">
                            <v-spacer></v-spacer>
                            <v-btn text @click="saveDialog = false" rounded>Annuleren</v-btn>
                            <v-btn color="secondary" depressed rounded @click="saveFilter">
                                <v-icon left>mdi-content-save</v-icon> {{ editingFilterId ? 'Aanpassen' : 'Opslaan' }}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>
        </div>
        <div v-if="filterTemplates.length > 0 && !hideSaved && !readonly" class="v-search__templates_wrapper">
            <v-select placeholder="Opgeslagen filter" v-model="selectedFilterTemplate" hide-details class="ml-2"
                :items="filterTemplates" item-value="content" item-text="name" @change="loadFilterTemplate" dense
                outlined flat>
                <template v-slot:item="{ item, on, attrs }">
                    <v-list-item v-on="on" v-bind="attrs" dense>
                        <v-list-item-content>
                            <v-list-item-title>{{ item.name }}</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action v-if="item.id" class="d-flex flex-row align-center my-0">
                            <v-btn icon small @click.stop="editFilter(item)">
                                <v-icon small>mdi-pencil</v-icon>
                            </v-btn>
                            <v-btn icon small @click.stop="confirmDeleteFilter(item)">
                                <v-icon small color="error">mdi-trash-can-outline</v-icon>
                            </v-btn>
                        </v-list-item-action>
                    </v-list-item>
                </template>
            </v-select>
        </div>
        <v-dialog v-if="deleteFilterTarget" :value="true" @input="deleteFilterTarget = null" width="420" max-width="100%">
            <v-card>
                <v-card-title class="mb-2"><span class="headline">Filter verwijderen</span></v-card-title>
                <v-card-text>Weet u zeker dat u de opgeslagen filter "{{ deleteFilterTarget.name }}" wilt verwijderen?</v-card-text>
                <v-card-actions class="grey lighten-3 py-3 px-3">
                    <v-spacer></v-spacer>
                    <v-btn text rounded @click="deleteFilterTarget = null">Annuleren</v-btn>
                    <v-btn color="error" depressed rounded @click="deleteFilter">
                        <v-icon left>mdi-trash-can-outline</v-icon> Verwijderen
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<style lang="scss" scoped>
.v-menu__content {
    overflow: visible;
    contain: none;
}

.v-search {
    align-items: center;

    &.v-text-field--solo {
        .v-input__control {
            min-height: 38px;
        }
    }

    &.eod-search__topbar {
        border: 1px solid #dddddd;
        width: 100%;
        max-width: 100%;
        height: 35px;
        margin: 0;
    }

    // Actieve inhoudelijke filter: primary (donkerblauwe) lijn rond het volledige
    // filterveld, consistent met de tijdsfilter (#1300/#1384).
    &.eod-search__topbar.v-search--active {
        border-color: var(--v-primary-base);
    }

    &.v-text-field {
        padding-top: 0;
        margin-top: 0;
        margin-bottom: 15px;

        .v-input__slot {
            margin-bottom: 0;
            background: #ffffff;
        }

        input {
            padding: 4px 0 8px;
            font-size: .8rem;
        }
    }

    .v-search__templates_wrapper {
        max-width: 200px;
    }

    .v-search__filter-wrapper {
        //border-bottom: 1px solid var(--v-primary-base);
        text-align: left;
        position:relative;
        height: 34px;
        margin-left: 5px;

        &.collapsable{
            overflow-y: hidden;
            padding-right:40px;

            .v-search__filter-dropdown{
                position:absolute;
                top:2px;
                right:5px;
            }

            .v-search__filter-items{
                padding-right:50px;
            }
        }

        &.open {
            overflow-y: visible;
                .v-search__filter-items{
                    background-color:#ffffff;
                    z-index: 999999;
                    width:100%;
                    height:auto;
                    overflow-y: visible;
                    border-radius: 10px;
                    border:1px solid #cccccc;
                }
        }

        .v-search__filter-items {
            padding: 4px 0 0 5px;
            border:1px solid transparent;
            position:absolute;
            left:0;
            top:0;
            width:100%;
        }
    }

    .input-group {
        border-radius: 0.85rem;
    }

    input {

        &:active,
        &:focus {
            outline: none;
        }
    }

    .v-search__filter-input {
        position: relative;
        flex-grow: 1;
        display:flex;
        height: 25px;
        padding:5px;
        margin-bottom: 4px;

        input {
            width: 100%;
        }
    }

    .v-search__filter-item {
        display: flex;
        margin-right: 4px;
        line-height: 1;
        margin-bottom: 4px;

        .v-search__filter-item__label {
            display: block;
            padding: .3rem .4rem .3rem .8rem;
            border-radius: 0.60rem 0 0 0.60rem;
            background-color: #dddddd;
            font-weight: normal;
            font-size: .8rem;
            color: #444444;
            height: 25px;
            line-height: 15px;
        }

        .v-search__filter-item__result {
            display: block;
            padding: .3rem .4rem;
            background-color: var(--v-primary-base);
            color: #ffffff;
            font-size: .8rem;
            height: 25px;
            line-height: 15px;
            font-weight: bold;
            // De verwijder-knop is nu een los icoon, dus de waarde-pill rondt altijd rechts af.
            border-radius: 0 0.60rem 0.60rem 0;
        }

        // Rood verwijder-icoon, consistent met de close van de tijdsfilter-chip.
        .v-search__filter-item__delete {
            margin: 0 2px;
            color: var(--v-error-base);
            cursor: pointer;

            &:hover {
                color: var(--v-error-darken1);
            }
        }
    }

    .v-search__dropdown {
        position: absolute;
        top: 100%;
        left: 0;
        background-color: #ffffff;
        border: 1px solid rgba(0, 0, 0, 0.125);
        border-radius: 0.1875rem;
        min-width: 200px;
        max-width: 100%;
        overflow: hidden;
        padding: .45rem 0;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
        margin-top: 4px;
        z-index: 100;
        max-height: 210px;
        overflow-y: auto;

        .v-search__dropdown-footer {
            padding: 5px 5px 0 5px;
            text-align: center;
            color: #444444;
            border-top: thin solid rgba(0, 0, 0, 0.12);
            font-size: .7rem;
        }

        .v-search__dropdown-item {
            padding: .25rem .85rem;
            font-size: .8rem;

            .v-icon {
                font-size: 1.4rem;
                margin-right: 10px;
            }

            &.active,
            &:hover {
                background: #f5f5f5;
            }

            &:hover {
                cursor: pointer;
            }
        }
    }
}
</style>
<script>
import eodDateTimePicker from './eod-datetime-picker.vue';
import eodDateRange from './eod-daterange.vue'

export default {
    name: 'v-search',
    components: {
        'eod-datetime-picker': eodDateTimePicker,
        eodDateRange
    },
    props: {
        config: Object | Array,
        value: Array,
        prependFilterItems: Array,
        objectType: String,
        defaultFilter: String,
        templateType: {
            type: String,
            default: 'FILTER'
        },
        flat: {
            type: Boolean,
            default: false
        },
        topbar: {
            type: Boolean,
            default: false
        },
        hideSaved: {
            type: Boolean,
            default: false
        },
        readonly:{
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            show_types: false,
            isDropdownOpen: false,
            search: '',
            search_timeout: null,
            module_items: [],
            module_items_totalcount: 0,
            recompute: 0,
            selectindex: 0,
            showMenu: false,
            dates: [],
            saveDialog: false,
            newFilterList: '',
            editingFilterId: null,
            deleteFilterTarget: null,
            filterAccess: 'PRIVATE',
            accessTypes: require('@/models/template').default.accessTypes,
            filterTemplates: [],
            selectedFilterTemplate: null,
            settings: require('./../classes/settings'),
            dateRange: []
        }
    },
    mounted() {
        if (this.objectType) {
            this.loadFilterTemplates();
        }
    },
    computed: {
        show_items() {
            return this.items.length > 0;
        },
        hasActiveFilters() {
            // Actief = er staat minstens één toegepaste filter (met result). Stuurt de
            // border rond de filter-items aan, consistent met de datumfilter (#1300).
            return Array.isArray(this.value) && this.value.some((filter) => filter.result);
        },
        types() {
            this.recompute;
            var types = [];
            for (let i = 0; i < this.config.length; i++) {
                if (this.config[i].label.toLowerCase().includes(this.search.toLowerCase())) {
                    var config = this.config[i];
                    config.selected = false;
                    types.push(config);
                }
            }

            if (this.selectindex < 0) {
                this.selectindex = 0;
            } else if (this.selectindex > types.length - 1) {
                this.selectindex = types.length - 1;
            }

            if (this.search != '') {
                if (types[this.selectindex]) {
                    types[this.selectindex].selected = true;
                }

            }

            if (types.length < 1) {
                this.show_types = false;
            }

            return types;
        },
        items() {
            this.recompute;
            var items = [];

            var active_filter = this.value[this.value.length - 1];

            if (active_filter && this.module_items.length > 0) {
                for (let i = 0; i < this.module_items.length; i++) {
                    var item = this.module_items[i];
                    item.selected = false;

                    if (active_filter.config.type == 'options') {
                        if (item.search_title.toLowerCase().includes(this.search.toLowerCase())) {
                            items.push(item);
                        }
                    } else {
                        items.push(item);
                    }
                }

                if (this.selectindex < 0) {
                    this.selectindex = 0;
                } else if (this.selectindex > items.length - 1) {
                    this.selectindex = items.length - 1;
                }

                if (this.search != '') {
                    if (items[this.selectindex]) {
                        items[this.selectindex].selected = true;
                    }
                }

            }

            return items;
        }
    },
    methods: {
        changeDate(date){
            this.$forceUpdate();
        },
        loadFilterTemplate(content) {
            this.$emit('input', content.filter);
            this.$emit('update');
        },
        loadFilterTemplates() {
            this.$eod.get('templates', ['id', 'name', 'content', 'access'], {
                where: [
                    {
                        column: 'type',
                        operator: '=',
                        value: this.templateType
                    },
                    {
                        column: 'object',
                        operator: '=',
                        value: this.objectType
                    }
                ]
            }).then(response => {
                if (response.data.data.templates) {
                    this.filterTemplates = response.data.data.templates.edges;
                    this.prependFilters();
                    this.$emit('templatesLoaded', this.filterTemplates);
                }
            });
        },
        prependFilters() {
            if (this.prependFilterItems) {
                for (let i = this.prependFilterItems.length - 1; i >= 0; i--) {
                    const filter = this.prependFilterItems[i];
                    this.filterTemplates.unshift(filter);
                }
            }

            if (this.defaultFilter) {
                for (let i = 0; i < this.filterTemplates.length; i++) {
                    const template = this.filterTemplates[i];
                    if (template.value == this.defaultFilter) {
                        this.selectedFilterTemplate = template.content;
                        this.$emit('input', template.content.filter);
                        this.$emit('update');
                        break;
                    }
                }
            }
        },
        setDate() {

            let active_filter = this.value[this.value.length - 1];
            if (active_filter) {
                if (active_filter.config.type == 'date-between') {
                    this.showMenu = false;

                    const from = this.dateRange[0] || null;
                    let label = this.$moment(from).format(active_filter.config.format ? active_filter.config.format : 'YYYY-MM-DD');
                    label += ' - ';

                    const until = this.dateRange[1] || null;
                    label += this.$moment(until).format(active_filter.config.format ? active_filter.config.format : 'YYYY-MM-DD');

                    this.addItemToFilter(null, {
                        id: [{
                            type: 'fixed',
                            value: from
                        }, {
                            type: 'fixed',
                            value: until
                        }],
                        search_title: label
                    });
                } else if (active_filter.config.type == 'date') {
                    if (this.dates.length == 2) {
                        this.showMenu = false;

                        this.addItemToFilter(null, {
                            id: this.dates,
                            search_title: this.dates[0] + ' - ' + this.dates[1]
                        });

                        this.dates = [];
                    }
                }
            }
        },
        saveFilter() {
            let template = {
                name: this.newFilterList,
                object: this.objectType,
                type: this.templateType,
                access: this.filterAccess,
                content: { filter: this.value }
            };

            // Bestaande filter aanpassen i.p.v. een nieuwe aanmaken.
            if (this.editingFilterId) {
                template.id = this.editingFilterId;
            }

            this.$eod.save('Template', template).then((response) => {
                this.$toaster.notify({
                    type: 'success',
                    title: 'Succes',
                    body: this.editingFilterId ? 'Filter is aangepast!' : 'Filter is succesvol opgeslaan!'
                });

                this.loadFilterTemplates();
            }).finally(() => {
                this.saveDialog = false;
                this.newFilterList = '';
                this.editingFilterId = null;
            });
        },
        prepareNewFilter() {
            // Nieuwe filter opslaan (geen edit-modus). Standaard privé.
            this.editingFilterId = null;
            this.newFilterList = '';
            this.filterAccess = 'PRIVATE';
        },
        editFilter(item) {
            if (!item || !item.id) { return; }
            this.editingFilterId = item.id;
            this.newFilterList = item.name;
            this.filterAccess = item.access || 'PRIVATE';
            // Laad de criteria zodat aanpassen vertrekt vanuit de bestaande filter.
            if (item.content && item.content.filter) {
                this.selectedFilterTemplate = item.content;
                this.$emit('input', item.content.filter);
                this.$emit('update');
            }
            this.saveDialog = true;
        },
        confirmDeleteFilter(item) {
            this.deleteFilterTarget = item;
        },
        deleteFilter() {
            const item = this.deleteFilterTarget;
            if (!item || !item.id) { this.deleteFilterTarget = null; return; }
            this.$eod.delete('Template', item.id).then(() => {
                this.$toaster.notify({
                    type: 'success',
                    title: 'Verwijderd',
                    body: 'Filter is verwijderd.'
                });
                if (this.selectedFilterTemplate === item.content) {
                    this.selectedFilterTemplate = null;
                }
                this.loadFilterTemplates();
            }).finally(() => {
                this.deleteFilterTarget = null;
            });
        },
        resetFilter() {

            const clearedFilters = [];
            if(this.selectedFilterTemplate){
                this.selectedFilterTemplate = null;
            } else {
                const filters = this.value;
                for (let i = 0; i < filters.length; i++) {
                    const filter = filters[i];
                    if(filter.config.readonly){
                        clearedFilters.push(filter);
                    }
                }
            }

            this.$emit('input', clearedFilters);
            this.$emit('update');
            
        },
        focusIn: function () {
            if (this.value.length > 0 && (this.value[this.value.length - 1].config.type == 'date' || this.value[this.value.length - 1].config.type == 'date-between') && this.value[this.value.length - 1].result == null) {
                this.showMenu = true;
            } else if (this.value.length > 0 && this.value[this.value.length - 1].result == null) {
                this.searching();
            } else {
                this.show_types = true;
            }
        },
        focusOut: function () {
            this.hideFilter();
            this.hideItems();
            this.search = '';
        },
        hideFilter() {
            this.show_types = false;
        },
        hideItems() {
            this.module_items = [];
        },
        searchFilter() {
            this.show_types = true;
            this.recompute++;
        },
        searching(event) {

            var active_filter = this.value[this.value.length - 1];

            if (typeof event != 'undefined') {
                if (this.search == '' && event.key == 'Backspace') {
                    if (active_filter) {
                        if (active_filter.result) {
                            this.value[this.value.length - 1].result = null;
                        } else {
                            this.value.splice(this.value.length - 1, 1);
                            if (this.showMenu) {
                                this.showMenu = false;
                            }
                        }
                    }

                    if (!this.value[this.value.length - 1]) {
                        this.hideItems();
                        this.show_types = true;
                    }
                    return false;
                }

                if (event.key == 'Enter') {

                    if (this.search == '') {
                        this.$emit('update');
                        return false;
                    }

                    if (this.show_types) {
                        if (this.types[this.selectindex]) {
                            this.addTypeToFilter(event, this.types[this.selectindex]);
                            return false;
                        }
                    } else if (this.module_items.length > 0) {
                        if (this.items[this.selectindex]) {
                            this.addItemToFilter(event, this.items[this.selectindex]);
                            return false;
                        }
                    }

                    if (active_filter) {
                        if ((active_filter.config.type == 'property' || active_filter.config.type == 'search') && !active_filter.result) {
                            this.addItemToFilter(event, {
                                id: this.search,
                                search_title: this.search
                            });
                            return false;
                        }
                    } else {
                        var filter = this.config[0];
                        this.value.push({
                            config: filter,
                            result: null
                        });
                        this.addItemToFilter(event, {
                            id: this.search,
                            search_title: this.search
                        });
                    }


                }

                if (event.key == 'ArrowDown') {
                    event.preventDefault();
                    if (this.show_types || this.module_items.length > 0) {
                        this.selectindex += 1;
                        this.recompute++;
                        return false;
                    } else if (active_filter) {
                        if (!active_filter.result) {
                            this.searching();
                        } else {
                            this.show_types = true;
                        }
                    }

                    this.$forceUpdate();

                    return false;
                }

                if (event.key == 'ArrowUp') {
                    event.preventDefault();
                    if (this.show_types || this.module_items.length > 0) {
                        this.selectindex -= 1;
                        this.recompute++;
                        return false;
                    }
                }
            }

            this.hideItems();
            if (this.search_timeout) {
                clearTimeout(this.search_timeout);
            }

            if (!active_filter) {
                this.searchFilter();
                return false;
            }

            this.search_timeout = setTimeout(() => {
                this.module_items = [];

                if (!active_filter.result) {
                    var filter = active_filter.config;
                    if (filter.type == 'module') {

                        let variables = {
                            orderBy: {
                                column: "name",
                                type: "asc"
                            },
                            offset: 0,
                            limit: 10,
                            where: []
                        }

                        if(filter.settings.module == 'searchUsers'){
                            variables.orderBy = {
                                column: "firstName",
                                type: "asc"
                            };
                        }

                        if (this.search != '') {
                            if(filter.settings.module == 'searchUsers'){
                                variables.search = this.search;
                            }else{
                                for (let i = 0; i < filter.settings.fields.length; i++) {
                                    variables.where.push({
                                        column: filter.settings.fields[i],
                                        operator: "ILIKE",
                                        value: "%" + this.search + "%",
                                        chain: "or"
                                    });
                                }
                            }
                        }

                        if (filter.settings.options) {
                            variables = {
                                ...variables,
                                ...filter.settings.options
                            };
                        }

                        let fields = filter.settings.fields.slice(0);
                        fields.push('id');

                        this.$eod.get(filter.settings.module, fields, variables)
                            .then(response => {
                                if (response.status == 200) {
                                    this.module_items_totalcount = response.data.data[filter.settings.module].totalCount;
                                    var items = response.data.data[filter.settings.module].edges;
                                    for (let i = 0; i < items.length; i++) {
                                        const item = items[i];

                                        var title = filter.settings.title;
                                        for (let j = 0; j < filter.settings.fields.length; j++) {
                                            const field = filter.settings.fields[j];
                                            title = title.split('{' + field + '}').join(item[field] || '');
                                        }

                                        item.selected = false;
                                        item.search_title = title.replace('()', '').trim();
                                        this.module_items.push(item);
                                    }
                                    this.selectindex = 0;
                                }
                            });
                    } else if (filter.type == 'relation' || filter.type == 'fixed') {

                        let variables = {
                            offset: 0,
                            limit: 10,
                            where: []
                        }

                        if (this.search && this.search != '') {
                            if(filter.settings.module == 'searchUsers'){
                                variables.search = this.search;
                            }else{
                                variables.orderBy = {
                                    column: "name",
                                    type: "asc"
                                }
                                for (let i = 0; i < filter.settings.fields.length; i++) {
                                    variables.where.push({
                                        column: filter.settings.fields[i],
                                        operator: "ILIKE",
                                        value: "%" + this.search + "%",
                                        chain: "or"
                                    });
                                }
                            }
                        }

                        if (filter.settings.options) {
                            variables = {
                                ...variables,
                                ...filter.settings.options
                            };
                        }

                        let fields = filter.settings.fields.slice(0);
                        fields.push('id');

                        this.$eod.get(filter.settings.module, fields, variables)
                            .then(response => {
                                this.module_items = [];
                                this.module_items_totalcount = 0;

                                if (response.status == 200) {
                                    this.module_items_totalcount = response.data.data[filter.settings.module].totalCount;
                                    var items = response.data.data[filter.settings.module].edges;
                                    for (let i = 0; i < items.length; i++) {
                                        const item = items[i];

                                        var title = filter.settings.title;
                                        for (let j = 0; j < filter.settings.fields.length; j++) {
                                            const field = filter.settings.fields[j];
                                            title = title.split('{' + field + '}').join(item[field] ? item[field] : '');
                                        }

                                        item.selected = false;
                                        item.search_title = title.replace('()', '').trim();
                                        this.module_items.push(item);

                                        if (this.module_items.length > 9) {
                                            break;
                                        }
                                    }
                                    this.selectindex = 0;
                                }
                            });
                    } else if (filter.type == 'distinct') {
                        
                         let variables = {
                            orderBy: {
                                column: filter.filter,
                                type: "asc"
                            },
                            offset: 0,
                            limit: 10,
                            distinct: true,
                            where: []
                        }

                        if (this.search != '') {
                            variables.where.push({
                                        column: filter.filter,
                                        operator: "ILIKE",
                                        value: "%" + this.search + "%",
                                        chain: "or"
                                    });
                        }
                    } else if (filter.type == 'options') {

                        let options = filter.settings.options;

                        if (typeof options == 'function') {
                            options = options(this.settings);
                        }

                        for (let i = 0; i < options.length; i++) {
                            const option = options[i];
                            this.module_items.push({
                                search_title: option.text,
                                id: option.value
                            });
                        }
                    } else if (filter.type == 'active') {
                        this.module_items.push({
                            search_title: 'Actief en niet-actief',
                            id: false
                        });
                        this.module_items.push({
                            search_title: 'Enkel actief',
                            id: true
                        });
                    } else if (filter.type == 'roles') {
                        let roles = filter.settings.roles.contacts;
                        if (this.$route.meta.roles) {
                            roles = filter.settings.roles[this.$route.meta.roles];
                        }

                        // Enkel rollen aanbieden die de ingelogde gebruiker mag zien (zelfde of lager).
                        const ownRole = this.$eod.getUser().getRole();
                        roles = this.settings.filterVisibleRoleNames(roles, ownRole ? ownRole.name : null);

                        for (let i = 0; i < roles.length; i++) {
                            const role = roles[i];
                            this.module_items.push({
                                search_title: this.$t(role),
                                id: role
                            });
                        }
                    } else if (filter.type == 'list') {

                        if (!this.$eod.getOrganizationSetting(filter.settings.list)) {
                            return false;
                        }

                        let listId = this.$eod.getOrganizationSetting(filter.settings.list).value;

                        let variables = {
                            orderBy: {
                                column: "name",
                                type: "asc"
                            },
                            offset: 0,
                            limit: 10,
                            where: [
                                {
                                    column: 'listId',
                                    operator: '=',
                                    value: listId,
                                    chain: 'and'
                                }
                            ]
                        }

                        if (this.search != '') {
                            for (let i = 0; i < filter.settings.fields.length; i++) {
                                variables.where.push({
                                    column: filter.settings.fields[i],
                                    operator: "ILIKE",
                                    value: "%" + this.search + "%",
                                    chain: "and"
                                });
                            }
                        }

                        let fields = filter.settings.fields.slice(0);
                        fields.push('id');

                        this.$eod.get('listItems', fields, variables)
                            .then(response => {
                                if (response.status == 200) {
                                    this.module_items_totalcount = response.data.data.listItems.totalCount;
                                    var items = response.data.data.listItems.edges;
                                    for (let i = 0; i < items.length; i++) {
                                        const item = items[i];

                                        var title = filter.settings.title;
                                        for (let j = 0; j < filter.settings.fields.length; j++) {
                                            const field = filter.settings.fields[j];
                                            title = title.split('{' + field + '}').join(item[field]);
                                        }

                                        item.selected = false;
                                        item.search_title = title.replace('()', '').trim();
                                        this.module_items.push(item);
                                    }
                                    this.selectindex = 0;
                                }
                            });
                    }
                } else {
                    this.searchFilter();
                }
            }, 200);

        },
        removeFilter: function (index) {
            const val = this.value;
            val.splice(index, 1);
            this.selectedFilterTemplate = null;
            this.$emit('input', val);
            this.$emit('update');
        },
        addItemToFilter: function (event, item) {
            if (event) {
                event.preventDefault();
            }

            const val = this.value;

            this.search = '';
            this.selectedFilterTemplate = null;
            val[this.value.length - 1].result = item;
            this.hideItems();
            this.selectindex = 0;

            this.$refs.input_search.focus();

            //this.show_types = true;
            this.$emit('input', val);
            this.$emit('update');
        },
        addTypeToFilter: function (event, filter) {
            event.preventDefault();

            this.search = '';
            this.selectedFilterTemplate = null;
            this.selectindex = 0;

            this.value.push({
                config: filter,
                result: null
            });

            if (filter.type == 'date' || filter.type == 'date-between') {
                this.showMenu = true;
            }

            this.hideFilter();
            this.searching();
        }
    }
}
</script>